import { CommonModule } from '@angular/common';
import { Component, inject, Input, OnDestroy, OnInit } from '@angular/core';
import { Logo, LogoComponent } from '@com-delta-idp/mnx-sitewide-header-ui';
import { AnalyticsDataPopulateService } from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import { PushPipe } from '@ngrx/component';
import { Subject } from 'rxjs';
import { LogoFacadeService } from '../../../data-access/facades/logo/logo-facade.service';

@Component({
  selector: 'idp-header-logo',
  standalone: true,
  imports: [CommonModule, LogoComponent, PushPipe],
  templateUrl: './header-logo.component.html',
  styleUrls: ['./header-logo.component.scss']
})
export class HeaderLogoComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  facade = inject(LogoFacadeService);
  emptyDetails = {} as Logo;
  @Input() isBusiness = false;
  analyticsService = inject(AnalyticsDataPopulateService);
  ngOnInit(): void {
    this.facade.init();
  }

  openPopup(event: { showPopup: boolean; url: string }): void {
    if (!event?.showPopup) {
      window.open(event.url, '_blank');
    }
  }

  analyticsEventTracking(element: HTMLElement): void {
    this.analyticsService.populateAnalyticsData(
      element,
      undefined,
      undefined,
      true
    );
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
